module.exports = __webpack_public_path__ + "img/one_select.0e4ea12c.png";